export default __webpack_public_path__ + "static/media/6ba168a7963e5595.cc2af5f2cdd63776e0cc97936a00a329.svg";